import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/auth",
    name: "auth",
    component: () => import("../views/Auth/AuthView.vue"),
    meta: {
      title: "Inicia sesión | Admin - PGS",
    },
  },
  {
    path: "/",
    name: "home",
    meta: {
      title: "Inicio | Admin - PGS",
    },
    component: () => import("../views/HomeView.vue"),
    redirect: "/companies",
    children: [
      {
        path: "/profile",
        name: "profile",
        meta: {
          title: "Perfil | Admin - PSG",
        },
      },
      {
        path: "/categories",
        name: "categories",
        component: () => import("../views/Categories/CategoriesView.vue"),
        meta: {
          title: "Categorías | Admin - PSG",
        },
      },
      {
        path: "/companies",
        name: "companies",
        component: () => import("../views/Companies/CompaniesView.vue"),
        meta: {
          title: "Comercios | Admin - PSG",
        },
      },
      {
        path: "/company/:id",
        name: "company",
        component: () => import("../views/Companies/CompanyView.vue"),
        meta: {
          title: "Comercio | Admin - PSG",
        },
      },
      {
        path: "/users",
        name: "users",
        component: () => import("../views/Users/UsersView.vue"),
        meta: {
          title: "Usuarios | Admin - PSG",
        },
      },
    ],
  },
  {
    path: "/resetPass",
    name: "resetPass",
    component: () => import("../views/Auth/ResetPassView.vue"),
    meta: {
      title: "Restablece tu contraseña | Admin - PSG",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  document.title = to.meta?.title ?? "Admin - PGS";
});

export default router;
